import { Network } from 'lucide-react';
import { useState } from 'react';
import { useFormikContext } from 'formik';

import { PortainerTunnelAddrField } from '@/react/portainer/common/PortainerTunnelAddrField';
import { PortainerUrlField } from '@/react/portainer/common/PortainerUrlField';
import { ConnectivityTestModal } from '@/react/edge/components/ConnectivityTestModal/ConnectivityTestModal';

import { Button } from '@@/buttons';

interface ConnectivityFieldsValues {
  EdgePortainerUrl: string;
  Edge: {
    TunnelServerAddress: string;
  };
}

interface Props {
  dataCyPrefix: string;
  isMTLSEnabled: boolean;
  urlTooltip?: string;
}

export function EdgeComputeConnectivityFields({
  dataCyPrefix,
  isMTLSEnabled,
  urlTooltip,
}: Props) {
  const { values } = useFormikContext<ConnectivityFieldsValues>();
  const [isConnectivityModalOpen, setIsConnectivityModalOpen] = useState(false);

  return (
    <>
      <PortainerUrlField fieldName="EdgePortainerUrl" tooltip={urlTooltip} />

      <PortainerTunnelAddrField fieldName="Edge.TunnelServerAddress" />

      <div className="form-group">
        <div className="col-sm-12">
          <Button
            color="default"
            icon={Network}
            onClick={() => setIsConnectivityModalOpen(true)}
            data-cy={`${dataCyPrefix}-test-connectivity-button`}
            className="!ml-0"
          >
            Test connectivity
          </Button>
        </div>
      </div>

      {isConnectivityModalOpen && (
        <ConnectivityTestModal
          portainerUrl={values.EdgePortainerUrl}
          tunnelServerAddr={values.Edge.TunnelServerAddress}
          isMTLSEnabled={isMTLSEnabled}
          onDismiss={() => setIsConnectivityModalOpen(false)}
        />
      )}
    </>
  );
}
